import { fromBool } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import * as React from 'react';
import ChatMessageStore from '../../../ChatMessageStore';
import { TPlainTextKey } from '../../../Translations';
import Button from '../../Form/Button';
import ChatEditor from './StyleControls/ChatEditor';
import ChatEditorProvider from './StyleControls/ChatEditorProvider';
import BlockStyleControls from './StyleControls/BlockStyleControls';
import InlineStyleControls from './StyleControls/InlineStyleControls';
import * as style from './style.module.css';

interface Props {
  store: ChatMessageStore;
  placeholder: TPlainTextKey;
}

const TeamChatMessageEditor: React.FC<Props> = ({ store, placeholder }) => {
  const submitChatMessage = () =>
    store.message.andThen((m) => fromBool(m.text.length > 0, m)).do(store.updating);

  const submit = (event: React.FormEvent<HTMLButtonElement>) => {
    event.preventDefault();
    submitChatMessage();
  };

  return (
    <div className={style.formWrapper}>
      <ChatEditorProvider>
        <form className={style.form}>
          <div className={style.textarea}>
            <ChatEditor
              store={store}
              submitChatMessage={submitChatMessage}
              placeholder={placeholder}
              contentClassName={style.editorContent}
              placeholderClassName={style.editorPlaceholder}
            />
          </div>
          <div className={style.editorControls}>
            <InlineStyleControls />
            <BlockStyleControls />
            <Button
              type="submit"
              className={style.submitButton}
              onClick={submit}
              disabled={store.state.kind === 'updating'}
              value="Send"
            />
          </div>
        </form>
      </ChatEditorProvider>
    </div>
  );
};
export default observer(TeamChatMessageEditor);
